jQuery(document).ready(function($){

    $('.news-wrapper').each(function(evt) {

        var $this = $(this);
        var $slider = $this.find('.news-slider');
        var $arrows = $this.find('.slider-nav .slider-arrow');

        $slider.owlCarousel({

            dots: true,
            responsive: {

                0: {
                    items: 1,
                    margin: 30,
                    stagePadding: 40
                },
                767: {

                    items: 2,
                    margin: 20
                },
                1024: {
                    items: 3,
                    margin: 40,
                },
                1400: {
                    items: 4,
                    margin: 40,
                }

            }
        });

        $arrows.click(function(evt) {

            evt.preventDefault();

            $slider.trigger($(this).attr('nav-role'));

        });

    });

    $('.testimonials-wrapper').each(function(evt) {

        var $this = $(this);
        var $slider = $this.find('.testimonials-slider');
        var $arrows = $this.find('.slider-nav .slider-arrow');

        $slider.owlCarousel({
            items: 1,
            margin: 0,
            dots: true
        });

        $arrows.click(function(evt) {

            evt.preventDefault();

            $slider.trigger($(this).attr('nav-role'));

        });

    });


    $('.services-wrapper').each(function(evt) {

        var $this = $(this);
        var $slider = $this.find('.services-slider');
        var $nav = $(this).find('.services-nav');

        $slider.owlCarousel({
            items: 1,
            margin: 0,
            dots: false,
            nav: false,
            autoHeight: true
        });

        $slider.on('changed.owl.carousel', function(e) {

            $nav.find('.tab').removeClass('active').eq(e.item.index).addClass('active');

        });

        $nav.find('.tab').click(function(evt) {

            evt.preventDefault();

            $slider.trigger('to.owl.carousel', parseInt($(this).attr('data-idx')))

            $(this).parent().find('.tab').removeClass('active');
            $(this).addClass('active');

        });

    });

    $( '.js-logo-collection-wrapper' ).each( function( evt) {
        var $this   = $( this );
        var $slider = $this.find( '.js-logo-collection' );
        var $arrows = $this.find('.slider-nav .slider-arrow');

        $slider.owlCarousel( {
            dots: true,

            responsive: {
                0: {
                    items: 2,
                    margin: 30,
                    stagePadding: 30,
                },

                767: {
                    items: 3,
                    margin: 40,
                },

                1024: {
                    items: 4,
                    margin: 40,
                },
            }
        } );

        $arrows.click( function( evt ) {
            evt.preventDefault();
            $slider.trigger( $( this ).attr( 'nav-role' ) );
        } );
    } );

    var $accordionWrapper = $('.accordion-wrapper');

    if( $accordionWrapper.length > 0 ){
        var $accordionItems = $accordionWrapper.find('.accordion-item');

        $accordionItems.each(function() {
            var $this = $(this);
            var $accordionHead = $this.find('.accordion-head');
            var $accordionBody = $this.find('.accordion-body');

            $accordionHead.on('click', function(){
                $this.toggleClass('active');
                $accordionBody.slideToggle('fast');
            });
        });
    }

    $('header .search-btn').click(function(evt) {

        evt.preventDefault();

        // Close all menus
        $('header .main-menu > .nav > li > a').removeClass('active');
        $('header .main-menu .sub-menu').removeClass('active');
        $('.mega-menu[role=menu]').removeClass('active');
        $('header').removeClass('open');

        if ( $(this).hasClass('active') ) {

            $(this).removeClass('active');
            $('header').removeClass('open');
            $('.mega-menu[role=search]').removeClass('active');

        } else {

            $(this).addClass('active');
            $('header').addClass('open');
            $('.mega-menu[role=search]').addClass('active');

            if ( $( this ).closest( 'header' ).hasClass( 'sticky-header' ) ) {
                $('.mega-menu[role=search]').addClass('sticky');
            }

        }

    });

    $('.menu-btn').click(function( event ) {
        event.preventDefault();
      $('.mobile-menu').toggleClass('open');
      $('body').toggleClass('open');

    });

    $('.mobile-menu .primary-menu .menu-item-has-children > a').click(function(evt) {

      evt.preventDefault();

      $(this).toggleClass('active');
      $(this).parent().find('.sub-menu').slideToggle();

    });

    $('.mobile-menu .secondary-menu .menu-item-has-children > a').click(function(evt) {

        evt.preventDefault();

        $(this).toggleClass('active');
        $(this).parent().find('.sub-menu').first().slideToggle();

    });

    $('.mega-menu').mouseleave(function() {

        //$('.mega-menu').removeClass('active');
        //$('header').removeClass('open');
        //$('header .search-btn').removeClass('active');

    });

    $('.jsInputUnderline').each(function() {

        var $this = $(this);

        $this.find('input').focus(function() {
            $this.addClass('underline');
        });

        $this.find('input').blur(function() {
            $this.removeClass('underline');
        });

    });

    $('header .main-menu > .nav > li > a').click(function(evt) {

        evt.preventDefault();

        // Close search box
        $('header .search-btn').removeClass('active');
        $('header').removeClass('open');
        $('.mega-menu[role=search]').removeClass('active');

        if ( $(this).hasClass('active') ) {

            $('header .main-menu > .nav > li > a').removeClass('active');
            $('header .main-menu .sub-menu').removeClass('active');
            $('.mega-menu[role=menu]').removeClass('active');
            $('.mega-menu[role=menu]').removeClass('sticky');
            $('header').removeClass('open');

        } else {

            $('header .main-menu > .nav > li > a').removeClass('active');
            $('header .main-menu .sub-menu').removeClass('active');
            $('.mega-menu[role=menu]').removeClass('active');
            $('header').removeClass('open');

            $(this).addClass('active');
            $(this).parent().find('.sub-menu').addClass('active');
            $('header').addClass('open');
            $('.mega-menu[role=menu]').addClass('active');

            if ( $( this ).closest( 'header' ).hasClass( 'sticky-header' ) ) {
                $('.mega-menu[role=menu]').addClass('sticky');
            }

        }

    });

    $(document).keyup(function(evt) {

        if ( evt.keyCode === 27 ) {

            $('header .main-menu > .nav > li > a').removeClass('active');
            $('header .main-menu .sub-menu').removeClass('active');
            $('.mega-menu').removeClass('active');
            $('header').removeClass('open');
            $('header .search-btn').removeClass('active');

        }

    });


    var $scrollLink = $('.jsScrollLink');

    if( $scrollLink.length > 0) {
        $scrollLink.on('click' , function(e) {
            e.preventDefault();
            if( $(this).parents('.sidebar-area--mobile').length > 0 ) {
                $(this).parents('.accordion-item').removeClass('active');

                // if mobile nav, hide nav after selection
                if ( ! window.matchMedia( '(min-width: 1024px' ).matches ) {
                    $(this).parents('.accordion-body').slideToggle('fast');
                }
            }
            var target = $(this).attr('href');
            $('html,body').animate({
                scrollTop: $(target).offset().top
            },500);
        });

        registerWaypoints();
    }


    function highlightMenuItem( id ) {
        var $sectionMenuItem = $( '.sidebar-navigation' );
        var $sidebarNavigationMobile = $('.sidebar-navigation-wrapper').first();
        var currentClassName = 'active';
        
        if ( 'undefined' !== typeof id && '' !== id ) {
            var text = $sidebarNavigationMobile.find( 'a[href="#' + id + '"]' ).text();
            $sectionMenuItem.find('.active').removeClass( currentClassName );
            $sectionMenuItem.find( 'a[href="#' + id + '"]' ).parent().addClass( currentClassName );
            if ( text !== '' ) {
                $sidebarNavigationMobile.find( '.sidebar-navigation-title' ).text( text );
            } else {
                $sidebarNavigationMobile.find( '.sidebar-navigation-title' ).text( 'Jump To' );
            }
        }
    }

    function registerWaypoints() {
        var $section = $('.quicknav_anchor');
        $section.each( function() {
            var id = $(this).attr('id');
            $( this ).waypoint( {
                handler: function ( direction ) {
                    if ( 'down' === direction ) {
                        highlightMenuItem( id );
                    }
                },
                offset: '100px'
            } );
            $( this ).waypoint( {
                handler: function ( direction ) {
                    if ( 'up' === direction ) {
                        highlightMenuItem( id );
                    }
                },
                offset: '-50%'
            } );
        } );
    }

    // Open Calendly on Support page
	var supportPage = $( '.page-id-12448' );

	function openCalendly() {
		Calendly.initPopupWidget({url: 'https://calendly.com/d/cgw-mpf-vw6/30-minute-tae-student-support-session'});
		return false;
	}

    // if ( supportPage.length ) {
		// 	openCalendly();
		// }
});

( function( $, document, window ) {
    'use strict';

    $( function() {
        var interval = 250;
        var visibleHeight = 800;
        var $body = $( 'body' );
        var activeClass = 'sticky-header--is-active';
        var $header = $( '.js-sticky-header' );
        var didScroll = false;

        var courseNavVisibleHeight = 1050;
        var courseActiveClass = 'has-sticky-course-nav';
        var courseDesktopNav = $( '.js-jump-menu-parent-desktop' );

        var hideMenus = function() {
            $('header .main-menu > .nav > li > a').removeClass('active');
            $('header .main-menu .sub-menu').removeClass('active');
            $('.mega-menu[role=menu]').removeClass('active');
            $('.mega-menu[role=menu]').removeClass('sticky');
            $('header').removeClass('open');

            $('header .search-btn').removeClass('active');
            $('.mega-menu[role=search]').removeClass('active');
        };

        var handleScroll = function() {
            console.log( 'scrolled' );
            var currentScrollTop = ( $( window ).scrollTop() || $( 'body' ).scrollTop() );

            if ( currentScrollTop > visibleHeight ) {
                if ( ! $header.hasClass( activeClass ) ) {
                    $header.addClass( activeClass );
                    $body.addClass( 'has-sticky-header' );
                    hideMenus();
                }
            } else {
                if ( $header.hasClass( activeClass ) ) {
                    $header.removeClass( activeClass );
                    $body.removeClass( 'has-sticky-header' );
                    hideMenus();
                }
            }

            if ( courseDesktopNav.length ) {
                if ( currentScrollTop > courseNavVisibleHeight ) {
                    $body.addClass( courseActiveClass );
                } else {
                    $body.removeClass( courseActiveClass );
                }
            }
        };

        $( window ).on( 'scroll', function() {
            didScroll = true;
        } );

        setInterval( function() {
            if ( didScroll ) {
                handleScroll();
                didScroll = false;
            }
        }, interval );

        $( window ).trigger( 'scroll' );
    } );
} )( jQuery, document, window );

( function( $, document, window ) {
    'use strict';

    $( function() {
        var isWide = null;

        var registerJumpTo = function() {
            $('.js-jump-menu').stick_in_parent({
                parent: '.container',
                inner_scrolling: false
            });
        };

        var deregisterJumpTo = function() {
            $('.js-jump-menu').trigger( 'sticky_kit:detach' );
        };

        var processJumpTo = function() {
            if ( window.matchMedia( '(min-width: 1024px' ).matches ) {
                if ( isWide === false || isWide === null ) {
                    isWide = true;
                    deregisterJumpTo();
                }
            } else {
                if ( isWide === true || isWide === null ) {
                    isWide = false;
                    registerJumpTo();
                    $('.js-jump-menu').trigger( 'sticky_kit:recalc' );
                }
            }
        };

        if( $('.sidebar-area').length > 0 ) {
            $( window ).on( 'resize', function() {
                processJumpTo();
            } );

            processJumpTo();
        }
    } );
} )( jQuery, document, window );

( function( $ ) {
    'use strict';

    $( function() {
        var activeClass = 'is-active';
        var $trigger = $( '.js-filter-trigger' );
        var $list = $( '.js-filter-content' );

        $trigger.on( 'click', function() {
            $trigger.toggleClass( activeClass );
            $list.slideToggle();
        } );
    } );
} )( jQuery );

/**
 * Replace course booking url in notice
 */
( function( $, document, window ) {
    'use strict';

    $( function() {
        var $bookButton = $( '.js-book-course' );
        var $bookTarget = $( '.js-book-course-trigger' );

        if ( $bookButton.length > 0 && $bookTarget.length > 0 ) {
            var url = $bookTarget.attr( 'href' );

            if ( url !== '' ) {
                $bookButton.attr( 'href', url );
            }
        }
    } );
} )( jQuery, document, window );
